import { GroupRowType, GroupTableFathom } from "helpers/models";
import sortArray from "report/common/sort-lable-fathom";

export default (result: GroupTableFathom) => {
  for (const layerId in result) {
    const layer = result[layerId];

    const defended = layer.defended;

    defended.sort((a: GroupRowType, b: GroupRowType) => {
      return sortArray.indexOf(a.label) - sortArray.indexOf(b.label);
    });

    const undefended = layer.undefended;

    undefended.sort((a: GroupRowType, b: GroupRowType) => {
      return sortArray.indexOf(a.label) - sortArray.indexOf(b.label);
    });
  }

  return result;
};
